import _Object$assign from 'babel-runtime/core-js/object/assign';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import { fetchBlogInfo, creatBlog, updateBlog } from '@/api/website/blog';
import { parseTime } from '@/filters/index';
// import { getToken } from '@/utils/auth'
// import { v2Host } from '@/config/host'
import { blogLangType, categoryType } from '../config';

export default {
  components: {},
  data: function data() {
    return {
      pageLoading: false,
      // 接口数据
      oldData: {},
      editType: '',
      formValue: {
        queryId: '',
        title: '',
        lang: '',
        type: '',
        content: '',
        cover_url: '',
        publish_time: parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}'),
        publisher_name: '',
        summary: '',
        publisher_job_title: '',
        publisher_head_img: '',
        slug: '',
        meta_title: '',
        meta_description: ''
      },
      coverFileList: [],
      avatarFileList: [],
      editorContent: '',
      InsertImageTitle: '',
      InsertImageAlt: ''
    };
  },

  watch: {
    $route: function $route(to, from) {
      // this.getList(this.query)
    },
    'formValue.publisher_head_img': function formValuePublisher_head_img(newVal, oldVal) {
      // 辅助校验，清除校验文案
      // this.$refs['form'].validateField('publisher_head_img')
    },
    'formValue.publisher_name': function formValuePublisher_name(val) {
      if (!val) {
        this.formValue.publisher_head_img = '';
        this.formValue.publisher_job_title = '';
      }
    },
    'formValue.cover_url': function formValueCover_url(val) {
      if (this.$refs['form']) {
        // 辅助校验，清除校验文案
        this.$refs['form'].validateField('cover_url');
      }
    }
  },
  computed: {
    formConfig: function formConfig() {
      return {
        labelPosition: 'left',
        labelWidth: '150px'
      };
    },
    formItemList: function formItemList() {
      var _this = this;

      return [{
        label: '语言版本：',
        prop: 'lang',
        type: 'radio-group',
        params: {
          options: blogLangType
        },
        rules: [{
          required: true,
          message: '请选择语言版本',
          trigger: 'change'
        }]
      }, {
        label: '博客名称：',
        type: 'input',
        prop: 'title',
        params: {
          style: 'width: 400px;'
        },
        rules: [{
          required: true,
          message: '请输入博客名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 200,
          message: '名称不能超过 200 个字符',
          trigger: 'blur'
        }]
      }, {
        label: '博客类型：',
        prop: 'type',
        type: 'radio-group',
        params: {
          options: categoryType
        },
        rules: [{
          required: true,
          message: '请选择博客类型',
          trigger: 'change'
        }]
      }, {
        label: '博客封面图：',
        type: 'business',
        subtype: 'file-uploader',
        prop: 'cover_url',
        rules: [{
          required: true,
          message: '请上传图片',
          trigger: 'change'
        }],
        params: function params() {
          var acceptType = ['jpg', 'png', 'jpeg'];
          var tip = '仅支持jpg, png, jpeg格式图片，推荐图片比例：16: 9，大小:  500kb以内';
          var temp = {
            disabled: false,
            drag: true,
            data: {
              local: 1,
              mod: 'website'
            },
            'with-credentials': true,
            acceptType: acceptType,
            tip: tip,
            style: 'width: 400px;',
            fileList: _this.coverFileList
          };
          return temp;
        },
        beforeUpload: this.beforeUpload,
        handleUploadSuccess: this.handleCoverUploadSuccess,
        handleRemove: this.handleCoverRemove
      }, {
        label: '发布时间：',
        type: 'date-picker',
        prop: 'publish_time',
        subtype: 'datetime',
        params: {
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          pickerOptions: {}
        },
        rules: [{
          required: true,
          message: '请选择发布时间',
          trigger: 'change'
        }]
      }, {
        label: '发布者姓名：',
        type: 'business',
        subtype: 'post-selector',
        prop: 'publisher_name',
        params: {
          style: 'width: 400px;',
          selectCallback: function selectCallback(item) {
            _this.formValue['publisher_job_title'] = item.job_title;
            _this.formValue['publisher_head_img'] = item.head_img;
            if (item.head_img) {
              _this.avatarFileList = [{
                name: item.head_img.split('/')[item.head_img.split('/').length - 1],
                url: item.head_img
              }];
            } else {
              _this.avatarFileList = [];
            }
          }
        },
        rules: [{
          min: 1,
          max: 20,
          message: '发布者姓名不能超过 20 个字符',
          trigger: 'change'
        }]
      }, {
        visible: function visible(_ref) {
          var formValue = _ref.formValue;

          return formValue.publisher_name !== '';
        },
        label: '发布者职位：',
        type: 'input',
        prop: 'publisher_job_title',
        params: {
          style: 'width: 400px;'
        },
        rules: [{
          min: 1,
          max: 100,
          message: '发布者职位不能超过 100 个字符',
          trigger: 'change'
        }]
      }, {
        visible: function visible(_ref2) {
          var formValue = _ref2.formValue;

          return formValue.publisher_name !== '';
        },
        label: '发布者头像：',
        type: 'business',
        subtype: 'file-uploader',
        prop: 'publisher_head_img',
        rules: [],
        params: function params() {
          var acceptType = ['jpg', 'png', 'jpeg'];
          var tip = '仅支持jpg, png, jpeg格式图片，大小:  500kb以内';
          var temp = {
            disabled: false,
            drag: true,
            data: {
              local: 1,
              mod: 'website'
            },
            'with-credentials': true,
            acceptType: acceptType,
            tip: tip,
            style: 'width: 400px;',
            fileList: _this.avatarFileList
          };
          return temp;
        },
        beforeUpload: this.beforeUpload,
        handleUploadSuccess: this.handleAvatarUploadSuccess,
        handleRemove: this.handleAvatarRemove
      }, {
        label: 'Slug信息：',
        type: 'input',
        prop: 'slug',
        params: {
          style: 'width: 400px;'
        },
        rules: [{ required: true, message: '请输入Slug信息', trigger: 'blur' }, {
          min: 1,
          max: 200,
          message: 'Slug信息不能超过 200 个字符',
          trigger: 'blur'
        }, { validator: this.validateSlug, trigger: 'blur' }]
      }, {
        label: 'Meta Title：',
        type: 'input',
        prop: 'meta_title',
        params: {
          style: 'width: 400px;'
        },
        rules: [{ required: true, message: '请输入Meta Title', trigger: 'blur' }, {
          min: 1,
          max: 60,
          message: 'Meta Title不能超过 60 个字符',
          trigger: 'blur'
        }]
      }, {
        label: 'Meta Description：',
        type: 'input',
        prop: 'meta_description',
        params: {
          style: 'width: 400px;'
        },
        rules: [{
          required: true,
          message: '请输入Meta Description',
          trigger: 'blur'
        }, {
          min: 1,
          max: 160,
          message: 'Meta Description不能超过 160 个字符',
          trigger: 'blur'
        }]
      }, {
        label: '摘要',
        prop: 'summary',
        type: 'input',
        subtype: 'textarea',
        rules: [{
          required: true,
          message: '请输入摘要内容',
          trigger: 'blur'
        }, {
          min: 1,
          max: 160,
          message: '摘要内容不能超过 160 个字符',
          trigger: 'blur'
        }]
      }, {
        label: '请输入正文：',
        type: 'business',
        subtype: 'main-editor',
        prop: 'content',
        rules: [{
          required: true,
          message: '请输入正文内容',
          trigger: 'blur'
        }]
      }];
    }
  },
  mounted: function mounted() {
    if (this.$route.params.id) {
      this.editType = 'edit';
      this.getBlogInfoById(this.$route.params.id);
    } else {
      this.editType = 'create';
    }
    // this.getList(this.query)
  },

  methods: {
    validateSlug: function validateSlug(rule, value, callback) {
      if (value) {
        var reg = /^[a-z0-9_-]+$/;
        if (!reg.test(value)) {
          callback(new Error('Slug信息只能由小写字母、数字、下划线、中划线组成'));
        } else if (value.startsWith('_') || value.startsWith('-')) {
          callback(new Error('Slug信息不能以下划线、中划线开头'));
        } else if (value.endsWith('_') || value.endsWith('-')) {
          callback(new Error('Slug信息不能以下划线、中划线结尾'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    getBlogInfoById: function getBlogInfoById(id) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.pageLoading = true;
                _context.prev = 1;
                _context.next = 4;
                return fetchBlogInfo(id, {});

              case 4:
                res = _context.sent;

                if (_.get(res, 'data.code', '') === 0) {
                  // this.oldData = _.get(res, 'data.data.info', {})
                  _this2.fillForm(_.get(res, 'data.data.info', {}));
                }
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.log(_context.t0);

              case 11:
                _this2.pageLoading = false;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 8]]);
      }))();
    },
    handleGoBack: function handleGoBack() {
      var _this3 = this;

      this.$confirm('是否放弃当前编辑内容，返回列表页？', '提示', {
        type: 'warning'
      }).then(function () {
        _this3.$router.push('/website/blog');
      }).catch(function () {
        //
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isPIC = ['jpg', 'png', 'jpeg'].some(function (item) {
        return file.type.indexOf(item) !== -1;
      });
      var isLt500 = file.size / 1024 < 500;
      if (isPIC && !isLt500) {
        this.$message.error('上传图片不能超过500kb');
        return isPIC && isLt500;
      }
      return true;
    },

    // 填充表单
    fillForm: function fillForm(data) {
      var obj = _.pick(data, ['lang', 'title', 'type', 'cover_url', 'content', 'publish_time', 'publisher_name', 'summary', 'publisher_job_title', 'publisher_head_img', 'slug', 'meta_title', 'meta_description']);
      obj.publish_time = parseTime(new Date(obj.publish_time).getTime(), '{y}-{m}-{d} {h}:{i}:{s}');
      _Object$assign(this.oldData, obj);
      obj.queryId = data.id;
      _Object$assign(this.formValue, obj);
      if (obj.cover_url) {
        this.coverFileList = [{
          name: data.cover_name,
          url: data.cover_url
        }];
      }
      if (obj.publisher_head_img) {
        this.avatarFileList = [{
          name: data.publisher_head_img.split('/')[data.publisher_head_img.split('/').length - 1],
          url: data.publisher_head_img
        }];
      }
    },

    // 封面
    handleCoverUploadSuccess: function handleCoverUploadSuccess(response, file, fileList) {
      if (response.code === 0) {
        // 当上传的图片都成功之后，为file_path赋值
        this.coverFileList = [{
          name: response.data.origin_name,
          url: response.data.url
        }];
        this.formValue.cover_url = response.data.file_path;
      } else {
        file.status = 'fail';
        this.$message({
          message: response.msg ? response.msg : '上传失败，请重新尝试',
          type: 'warning'
        });
      }
    },
    handleCoverRemove: function handleCoverRemove(file, fileList) {
      this.coverFileList = [];
      this.formValue.cover_url = '';
    },

    // 头像
    handleAvatarUploadSuccess: function handleAvatarUploadSuccess(response, file, fileList) {
      if (response.code === 0) {
        // 当上传的图片都成功之后，为file_path赋值
        this.avatarFileList = [{
          name: response.data.origin_name,
          url: response.data.url
        }];
        this.formValue.publisher_head_img = response.data.file_path;
      } else {
        file.status = 'fail';
        this.$message({
          message: response.msg ? response.msg : '上传失败，请重新尝试',
          type: 'warning'
        });
      }
    },
    handleAvatarRemove: function handleAvatarRemove(file, fileList) {
      this.avatarFileList = [];
      this.formValue.publisher_head_img = '';
    },
    submitBlog: function submitBlog() {
      var postData = {};
      _Object$assign(postData, _.pick(this.formValue, ['title', 'lang', 'type', 'cover_url', 'content', 'summary', 'publish_time', 'publisher_name', 'publisher_job_title', 'publisher_head_img', 'slug', 'meta_title', 'meta_description']));
      if (this.editType === 'create') {
        this.handleCreateBlog(postData);
      } else {
        this.handleUpdateBlog(postData);
      }
    },
    handleCreateBlog: function handleCreateBlog(postData) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.pageLoading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return creatBlog(postData);

              case 4:
                res = _context2.sent;

                _this4.pageLoading = false;
                if (_.get(res, 'data.code', '') === 0) {
                  _this4.$message({
                    message: '创建成功',
                    type: 'success'
                  });
                  _this4.$router.push('/website/blog');
                } else {
                  _this4.$message(_.get(res, 'data.msg', ''));
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](1);

                _this4.pageLoading = false;
                //

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[1, 9]]);
      }))();
    },
    handleUpdateBlog: function handleUpdateBlog(postData) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var omitPostData, key, hasPosterChange, _key, res;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.pageLoading = true;
                _context3.prev = 1;
                omitPostData = {};
                // 遍历对比json

                for (key in postData) {
                  if (postData[key] !== _this5.oldData[key]) {
                    omitPostData[key] = postData[key];
                  }
                }
                // 检查修改项是否有改动，允许为空改动
                hasPosterChange = false;

                for (_key in omitPostData) {
                  if (_key === 'publisher_name' || _key === 'publisher_job_title' || _key === 'publisher_head_img') {
                    hasPosterChange = true;
                  }
                }
                // 发布者信息捆绑提交
                if (hasPosterChange) {
                  omitPostData.publisher_name = postData.publisher_name;
                  omitPostData.publisher_job_title = postData.publisher_job_title;
                  omitPostData.publisher_head_img = postData.publisher_head_img;
                }
                _context3.next = 9;
                return updateBlog(_this5.formValue.queryId, omitPostData);

              case 9:
                res = _context3.sent;

                _this5.pageLoading = false;
                if (_.get(res, 'data.code', '') === 0) {
                  _this5.$message({
                    message: '更新成功',
                    type: 'success'
                  });
                  _this5.$router.push('/website/blog');
                } else {
                  _this5.$message(_.get(res, 'data.msg', ''));
                }
                _context3.next = 17;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3['catch'](1);

                _this5.pageLoading = false;
                //

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[1, 14]]);
      }))();
    },
    handleSubmitBlog: function handleSubmitBlog() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var canSubmit;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this6.$refs.form.validate();

              case 2:
                canSubmit = _context4.sent;

                if (canSubmit) {
                  _this6.submitBlog();
                }

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    }
  }
};